export const EmployeePermission = (json: IEmployeePermissions): IEmployeePermissions => {
	const fromJSON = (itemJson: IEmployeePermissions) => {
		const { ...rest } = itemJson

		return {
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const employeePermissionToJSON = (obj: Partial<IEmployeePermissions>): Partial<IEmployeePermissions> => {
	const { ...rest } = obj
	return {
		...rest,
	}
}

export const EmployeeRole = (json: IEmployeeRole): IEmployeeRole => {
	const fromJSON = (itemJson: IEmployeeRole) => {
		const { ...rest } = itemJson

		return {
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const employeeRoleToJSON = (obj: Partial<IEmployeeRole>): Partial<IEmployeeRole> => {
	const { ...rest } = obj
	return {
		...rest,
	}
}
